import { Modal, Alert } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PincodeInput from "~/components/form/PincodeInput.jsx";
import { TacometerInput } from "~/components/form/TacometerInput.jsx";
import { $t } from "~/i18n.js";
import { saveMaterialTab } from "~/redux/materiaal/materiaal.actions.js";

export const EditInspection = ({
  visible,
  currentMaterial,
  inspection,
  last_motor_minutes,
  closeModal,
}) => {
  const dispatch = useDispatch();

  const [pincode, setPincode] = useState(null);
  const [total_motor_minutes, setMotorMinutes] = useState(null);

  const motor_format = currentMaterial.motor_format || "decimal";

  useEffect(() => {
    if (visible) {
      setMotorMinutes(inspection?.total_motor_minutes ?? last_motor_minutes);
      setPincode(null);
    }
  }, [visible]);

  const disabled =
    pincode?.length !== 4 ||
    total_motor_minutes === null ||
    total_motor_minutes === undefined;

  const [saving, setSaving] = useState(false);
  const triggerSave = async () => {
    setSaving(true);
    const res = await dispatch(
      saveMaterialTab({
        activeTab: "meldingen",
        materialID: currentMaterial.id,
        payload: {
          action: "update",
          inspection_id: inspection.id,
          total_motor_minutes,
          pincode,
        },
      })
    );
    setSaving(false);
    if (res) {
      closeModal();
    }
  };

  // Show motor time warning if new value is less than the previous recorded value
  // (but not less than the inspection's own original value which is being edited)
  const previousMinutes =
    last_motor_minutes !== null &&
    last_motor_minutes !== inspection?.total_motor_minutes
      ? last_motor_minutes
      : null;

  return (
    <Modal
      title={$t("Motortijd aanpassen")}
      confirmLoading={saving}
      open={visible}
      onCancel={closeModal}
      okButtonProps={{ disabled }}
      okText={$t("Opslaan")}
      width={400}
      onOk={triggerSave}
    >
      <p style={{ marginBottom: 12 }}>
        {$t("Pas de motortijd van de inspectie aan. Je moet opnieuw aftekenen met je pincode.")}
      </p>

      {currentMaterial.category === "kist" &&
        currentMaterial.kist_configuration !== "Glider" && (
          <div style={{ marginBottom: 16 }}>
            <p className="bold label">{$t("Motortijd")}</p>

            <div style={{ marginBottom: 8 }}>
              <p>{$t("Nieuw")}:</p>
              <TacometerInput
                motor_format={motor_format}
                readOnly={false}
                onChange={setMotorMinutes}
                value={total_motor_minutes}
              />
            </div>

            {previousMinutes !== null &&
              total_motor_minutes < previousMinutes && (
                <Alert
                  style={{ marginBottom: 8 }}
                  type="error"
                  message={$t(
                    "Let op, de ingevulde motortijd is minder dan de vorige. Check of dit klopt."
                  )}
                />
              )}

            <div>
              <p>{$t("Vorige")}:</p>
              <TacometerInput
                motor_format={motor_format}
                value={last_motor_minutes}
                readOnly={true}
                onChange={() => {}}
              />
            </div>
          </div>
        )}

      <div>
        <p style={{ marginBottom: 6 }}>{$t("Teken af met je pincode")}:</p>
        <PincodeInput value={pincode} onComplete={setPincode} />
      </div>
    </Modal>
  );
};
